import { useEffect, useState } from "react";
import {
  HouseholdLearner,
  getStoredActiveLearner,
  getStoredActiveLearnerId,
  getStoredHouseholdLearners,
  onActiveLearnerChange
} from "../utils/studentSession";

export const useActiveLearner = () => {
  const [learners, setLearners] = useState<HouseholdLearner[]>(() => getStoredHouseholdLearners());
  const [activeLearner, setActiveLearner] = useState<HouseholdLearner | null>(() => getStoredActiveLearner());

  useEffect(() => {
    const sync = () => {
      setLearners(getStoredHouseholdLearners());
      setActiveLearner(getStoredActiveLearner());
    };
    return onActiveLearnerChange(sync);
  }, []);

  return {
    learners,
    activeLearner,
    activeLearnerId: getStoredActiveLearnerId()
  };
};
